import { useState, useEffect } from 'react';
let isChecked = false;
let isSupported = true;
export default function useHasObjectFit() {
    const [isEnabled, setEnabled] = useState(isSupported);
    useEffect(() => {
        if (!isChecked) {
            const image = new Image();
            isChecked = true;
            isSupported = 'object-position' in image.style;
        }
        setEnabled(isSupported);
    }, []);
    return isEnabled;
}
//# sourceMappingURL=useHasObjectFit.js.map